module.exports = __webpack_public_path__ + "static/media/andrej-qa.df080875.png";